// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import { Group, GroupDetail } from '../../core/models/groups.model';
import { IAMUser } from '@app/core';

export enum GroupDetailsActionTypes {
  SELECT_GROUP = '[Group Details] SELECT_GROUP',
  SELECT_USERS_FOR_GROUP = '[Group Details] SELECT_USERS_FOR_GROUP',
  SELECT_SCOPE_CATEGORY = '[Group Details] SELECT_SCOPE_CATEGORY',
  SELECT_SCOPE_CONSTRAINTS = '[Group Details] SELECT_SCOPE_CONSTRAINTS',
  GROUP_DETAILS_LOADING = '[Group Details] GROUP_DETAILS_LOADING',
  GROUP_DETAILS_LOAD_COMPLETE = '[Group Details] GROUP_DETAILS_LOAD_COMPLETE',
  GROUP_DETAILS_LOAD_FAILED = '[Group Details] GROUP_DETAILS_LOAD_FAILED',
  CLEAR_GROUP_USER_SELECTIONS = '[Group Details] CLEAR_GROUP_USER_SELECTIONS',
  GROUP_DETAILS_LOADING_USERS = '[Group Details - Users ] GROUP_DETAILS_LOADING USERS',
  GROUP_DETAILS_LOAD_COMPLETE_USERS = '[Group Details Users] GROUP_DETAILS_LOAD_COMPLETE_USERS',
  GROUP_DETAILS_LOAD_FAILED_USERS = '[Group Details Users] GROUP_DETAILS_LOAD_FAILED_USERS',
  GROUP_DETAILS_USERS_REMOVE_BY_ID = '[Group Details Users Remove by id] GROUP_DETAILS_USERS_REMOVE_BY_ID',
}

export class SelectGroupAction implements Action {
  readonly type = GroupDetailsActionTypes.SELECT_GROUP;
  constructor(public payload: Group) {
  }
}

export class SelectUsersForGroupAction implements Action {
  readonly type = GroupDetailsActionTypes.SELECT_USERS_FOR_GROUP;
  constructor(public payload: { groupId: string; selectedUsers: IAMUser[] }) {
    this.payload = payload;
  }
}

export class LoadingGroupDetailsAction implements Action {
  readonly type = GroupDetailsActionTypes.GROUP_DETAILS_LOADING;
  constructor(public payload: string) {
  }
}

export class CompleteLoadGroupDetailsAction implements Action {
  readonly type = GroupDetailsActionTypes.GROUP_DETAILS_LOAD_COMPLETE;
  constructor(public payload: Group) {
    this.payload = payload;
  }
}

export class FailLoadGroupDetailsAction implements Action {
  readonly type = GroupDetailsActionTypes.GROUP_DETAILS_LOAD_FAILED;
  constructor(public payload: string) {
    this.payload = payload;
  }
}

export class ClearGroupUserSelectionsAction implements Action {
  readonly type = GroupDetailsActionTypes.CLEAR_GROUP_USER_SELECTIONS;
  constructor(public payload: string) {}
}

export class LoadingUsersFromGroupAction implements Action {
  readonly type = GroupDetailsActionTypes.GROUP_DETAILS_LOADING_USERS;
  constructor(public payload: string) {
  }
}

export class CompleteLoadUsersFromGroupAction implements Action {
  readonly type = GroupDetailsActionTypes.GROUP_DETAILS_LOAD_COMPLETE_USERS;
  constructor(public payload: any, public users: any) {}
}

export class FailLoadUsersFromGroupAction implements Action {
  readonly type = GroupDetailsActionTypes.GROUP_DETAILS_LOAD_FAILED_USERS;
  constructor(public payload: string) {
  }
}

export class RemoveUserFromGroupAction implements Action {
  readonly type = GroupDetailsActionTypes.GROUP_DETAILS_USERS_REMOVE_BY_ID;
  constructor(public payload: string, public userGroupId: string) {}
}

export type GroupDetailsActions =
  | SelectGroupAction
  | SelectUsersForGroupAction
  | LoadingGroupDetailsAction
  | CompleteLoadGroupDetailsAction
  | FailLoadGroupDetailsAction
  | ClearGroupUserSelectionsAction
  | LoadingUsersFromGroupAction
  | CompleteLoadUsersFromGroupAction
  | FailLoadUsersFromGroupAction
  | RemoveUserFromGroupAction;



// WEBPACK FOOTER //
// ./src/app/access-management/state/group-details/group-details.actions.ts